// extracted by css-extract-rspack-plugin
export default {"cls1":"FeatureFeedback-cls1_SpX","cls2":"FeatureFeedback-cls2_pw- FeatureFeedback-cls1_SpX"};